function dataLayerPageView(){
  const dataLayerVariables = {
    event: "page_view",
    id: +new Date() + "-" + (Math.floor(Math.random() * 10000)),
    user_data: localStorage.getItem('puissanteData') ? JSON.parse(localStorage.getItem('puissanteData')) : null
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerVariables);
}

function dataLayerViewItem(productData){
  const dataLayerVariables = {
    event: "view_item",
    id: +new Date() + "-" + (Math.floor(Math.random() * 10000)),
    user_data: localStorage.getItem('puissanteData') ? JSON.parse(localStorage.getItem('puissanteData')) : null,
    affiliation: "Website",
    currency: "EUR",
    value: productData.price / 100,
    items: [{
      item_id: productData.id.toString(),
      item_name: productData.title,
      affiliation: "Website",
      currency: "EUR",
      index: 0,
      item_brand: productData.vendor,
      price: productData.price / 100,
      quantity: 1
    }]
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerVariables);
}

function dataLayerAddToCart(productData){
  const productQuantity = document.querySelector('.quantity-selector input[name="quantity"]')
  const dataLayerVariables = {
    event: "add_to_cart",
    id: +new Date() + "-" + (Math.floor(Math.random() * 10000)),
    user_data: localStorage.getItem('puissanteData') ? JSON.parse(localStorage.getItem('puissanteData')) : null,
    affiliation: "Website",
    currency: "EUR",
    value: (productQuantity ? parseInt(productQuantity.value) : 1) * parseInt(productData.price) / 100,
    items: [{
      item_id: productData.id.toString(),
      item_name: productData.title,
      affiliation: "Website",
      currency: "EUR",
      index: 0,
      item_brand: productData.vendor,
      price: productData.price / 100,
      quantity: (productQuantity ? parseInt(productQuantity.value) : 1)
    }]
  }
  
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerVariables);
}

function dataLayerBeginCheckout(cartData){
  let items = [];
  for (const productData of cartData.items) {
    items.push({
      item_id: productData.id.toString(),
      item_name: productData.product_title,
      affiliation: "Website",
      currency: cartData.currency,
      index: cartData.items.findIndex(object => {
        return object.id === productData.id;
      }),
      item_brand: productData.vendor,
      item_variant: productData.variant_title,
      price: productData.price / 100,
      quantity: productData.quantity
    })
  }
  const dataLayerVariables = {
    event: "begin_checkout",
    id: +new Date() + "-" + (Math.floor(Math.random() * 10000)),
    user_data: localStorage.getItem('puissanteData') ? JSON.parse(localStorage.getItem('puissanteData')) : null,
    affiliation: "Website",
    currency: cartData.currency,
    value: cartData.total_price / 100,
    items: items
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerVariables);
}

function dataLayerPurchase(){
  /*
  const transaction_id = "";
  const total_price = "";
  const value_without_tax = "";
  const shipping_price = "";
  const shipping_price = "";
  const tax_price = "";
  const currency = "EUR";
  const payment_type = "";

  const items = [];
  
  const dataLayerPurchaseVariables = {
    'event': 'purchase',
    id: +new Date() + "-" + (Math.floor(Math.random() * 10000)),
    user_data: localStorage.getItem('puissanteData') ? JSON.parse(localStorage.getItem('puissanteData')) : null,
    'transaction_id': transaction_id,
    'affiliation': "Website",
    'value': total_price,
    'value_without_tax': value_without_tax,
    'shipping': shipping_price,
    'tax': tax_price,
    'currency': currency,
    'payment_type': payment_type,
    'items': items,
    'user_data': user_data
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerPurchaseVariables);*/
}